import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule, Routes} from '@angular/router';


import {MachineConfigurationComponent} from '@components/administration/machine/machine-configuration/machine-configuration.component';
import {MachineComponent} from '@components/administration/machine/machine.component';
import {AuthorizationGuardService} from '../../../shared/authorization-guard/authorization-guard.service';

const routes: Routes = [
  {path: '', redirectTo: '/login', pathMatch: 'full'},
  {path: 'machines', component: MachineComponent, canActivate: [AuthorizationGuardService]},
  {path: 'machines/:details', component: MachineConfigurationComponent, canActivate: [AuthorizationGuardService]}
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ]
})
export class MachineRoutingModule {
}
